import { types } from "../type";

const initialState = {
  rules: null,
  ruleError: "",
  ruleStatus: 0,
  activeNow: null,
  inActiveNow: null,
  ruleResponse: "",
  ruleLoading: false,
  ruleCreateError: "",
  ruleCreateStatus: 0,
  ruleCreateResponse: "",
  ruleCreateLoading: false
};

const ruleReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.RuleTypes.RULE_SET_LOADING:
      return {
        ...state,
        ruleLoading: payload
      };
    case types.RuleTypes.RULE_SET_CREATE_LOADING:
      return {
        ...state,
        ruleCreateLoading: payload
      };
    case types.RuleTypes.RULE_CLEAR_ERRORS:
      return {
        ...state,
        ruleError: "",
        ruleCreateError: ""
      };
    case types.RuleTypes.RULE_GET_ERRORS:
      return {
        ...state,
        ruleLoading: false,
        ruleError: payload.data.message,
        ruleStatus: payload.status
      };
    case types.RuleTypes.RULE_CREATE_GET_ERRORS:
      return {
        ...state,
        ruleCreateLoading: false,
        ruleCreateError: payload.data.message,
        ruleCreateStatus: payload.status
      };
    case types.RuleTypes.RULE_CLEAR_RESULT:
      return {
        ...state,
        ruleResponse: "",
        ruleCreateResponse: ""
      };
    case types.RuleTypes.CREATE_RULE:
      return {
        ...state,
        ruleCreateLoading: false,
        ruleCreateError: "",
        ruleCreateStatus: 0,
        ruleCreateResponse: payload.message,
        rules: payload.rules,
        activeNow: payload.rules.activeNow,
        inActiveNow: payload.rules.inActiveNow
      };
    case types.RuleTypes.RULE_ACTIVATE:
      return {
        ...state,
        ruleLoading: false,
        ruleError: "",
        ruleStatus: 0,
        ruleResponse: payload.message,
        rules: payload.rules,
        activeNow: payload.rules.activeNow,
        inActiveNow: payload.rules.inActiveNow
      };
    case types.RuleTypes.DELETE_RULE:
      return {
        ...state,
        ruleLoading: false,
        ruleError: "",
        ruleStatus: 0,
        ruleResponse: payload.message,
        rules: payload.rules,
        activeNow: payload.rules.activeNow,
        inActiveNow: payload.rules.inActiveNow
      };
    case types.RuleTypes.GET_RULES:
      return {
        ...state,
        ruleLoading: false,
        rules: payload.rules,
        activeNow: payload.rules.activeNow,
        inActiveNow: payload.rules.inActiveNow
      };
    case types.RuleTypes.RULE_UNMOUNT:
      return {
        ...state,
        ruleLoading: false,
        rules: null,
        activeNow: null,
        inActiveNow: null
      };
    default:
      return state;
  }
};

export default ruleReducer;
